<template>
  <div
    class="nav-mobile-link-container"
    :class="{ 'nav-mobile-link--subdrop-open': open }"
  >
    <div class="nav-mobile-link-wrapper">
      <T3Link
        :to="getLink(link)"
        class="nav-mobile-link"
        active-class
      >
        <span @click="handleLinkClick">
          {{ link.title }}
        </span>
      </T3Link>

      <div
        v-if="withSubdrop"
        class="nav-mobile-link-arrow"
        @click="handleSubdropToggle"
      >
        <SvgIconArrowMenu />
      </div>
    </div>

    <NavMobileSubdrop
      v-if="withSubdrop"
      :root-link="link"
      :locale="locale"
      :open="open!"
      @close="handleSubdropToggle"
      @link-click="handleLinkClick"
    />
  </div>
</template>

<script setup lang="ts">
import type { T3Link } from '@t3headless/nuxt-typo3'
import { computed } from 'vue'

import SvgIconArrowMenu from '~ui/assets/icons/icon-arrow-menu.svg'
import type { INavigation, INavigationWithMedia } from '~ui/types'

const props = defineProps<{
  link: INavigation | INavigationWithMedia
  index?: number
  locale: 'en' | 'pl' | 'de'
  open?: boolean
}>()

const withSubdrop = computed(() => {
  return Array.isArray(props.link.children) && props.link.children.length
})

const getLink = (link: INavigation): T3Link => {
  return { href: link.link, target: link.target }
}

const emit = defineEmits<{
  (event: 'link-click'): void
  (event: 'toggle-subdrop', index?: number): void
}>()

const handleLinkClick = () => emit('link-click')
const handleSubdropToggle = () => emit('toggle-subdrop', props.index)
</script>

<style lang="scss">
.nav-mobile-link {
  &-container {
    font-size: rem(20px);
    font-weight: 600;
    padding-inline: rem($container-padding);
  }

  &-wrapper {
    display: flex;
    align-items: center;

    & > *:first-child:last-child {
      flex-grow: 1;
    }
  }

  color: color(grey-800);
  text-underline-offset: 4px;
  transition: color 0.4s;

  &.router-link-exact-active {
    text-decoration: 2px underline;
  }

  & > span {
    display: block;
    padding-block: rem($container-padding);
  }

  &-arrow {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    height: 100%;

    & svg {
      transition: rotate 0.4s;
      height: 32px;
      width: 32px;
      rotate: -90deg;

      & path {
        fill: #a0a7b3;
        transition: fill 0.4s;
      }
    }
  }

  &--subdrop-open &-arrow svg path {
    fill: color(primary);
  }
}
</style>
